// This is a container component. It is almost identical to ActionsPanel.
// I've kept it separate in case of a need to pass different
// props or classNames

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import s from './ContentPanel.css';


export default class ContentPanel extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
  }

  constructor(props) {
    super(props);
    // creating ref to parent div
    this.parentContainerRef = null;

    this.setMyRef = element => {
      this.parentContainerRef = element;
    };
  }

  render() {
    return (
      <div className={cx(s.component, this.props.className)} ref={this.setMyRef}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentPanel/ContentPanel.js